import { Stack } from "expo-router";

export default function CollectionLayout() {
  return (
    <>
      <Stack>
        <Stack.Screen
          name="form"
          options={{
            animation: "fade",
            animationDuration: 150,
          }}
        />
      </Stack>
    </>
  );
}
